import { useEffect, useRef, useState } from "react";
import { getLocations, getLocationsFind } from "../../Services/Properties";
import { TextField, Autocomplete } from '@mui/material';
import LoacationMaps from "../listing-ceation/TitleAndDesc/location-map";
import { useTranslation } from "react-i18next";
import { PropertyReport } from "../../Models/PropertyReport";


const LocationReport: React.FunctionComponent<{ errors: any, property: PropertyReport, OnChangeLocation: any }> = (props) => {

    const [inputValue, setInputValue] = useState<string>([props.property.heroSection?.address?.address ?? "",].filter(Boolean).join(", ") || "");
    const [options, setOptions] = useState<any[]>([]);
    const [error, setError] = useState<string | null>(null);
    const autocompleteServiceRef = useRef<google.maps.places.AutocompleteService | null>(null);
    const { t } = useTranslation();

    useEffect(() => {
        setInputValue(
            props.property?.heroSection?.address?.address ||
            props.property?.heroSection?.location ||
            ""
        );
    }, [props.property]);

    useEffect(() => {
        // Load Google Maps script dynamically
        const googleMapScript = document.createElement('script');
        googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyD_rakAcENsIZ3PvTOXdRmepMG89RJ7YlI&libraries=places`;
        googleMapScript.async = true;
        window.document.body.appendChild(googleMapScript);
        googleMapScript.onload = () => {
            if (window.google) {
                autocompleteServiceRef.current = new google.maps.places.AutocompleteService();
            }
        };
        return () => {
            window.document.body.removeChild(googleMapScript);
        };
    }, []);


    const handleSelectChangeLocation = (event: any, newValue: any, co: any) => {
        if (newValue) {
            setInputValue(newValue)
            setOptions([])
            getLocationsFind(newValue, co).then((data) => {
                props.OnChangeLocation({
                    city: data.city_en,
                    country: props.property.heroSection?.address?.country,
                    latitude: data.lat,
                    longitude: data.lng,
                    subCommunity: data.sub_community_en,
                    Community: data.community_en,
                    location: data.sub_community_en + "," + data.community_en + "," + data.city_en,
                })
            }).catch((error: any) => {
                console.log("error")
            })
        }
    }

    const handleSelect = (address: string | null) => {
        if (!address || !window.google) return;
        setInputValue(address);
        setError(null); // Clear previous error
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address, language: "en" }, (results: any, status) => {
            if (status === "OK" && results && results.length > 0 && results[0].geometry) {
                const addressComponents = results[0].address_components;
                const getComponent = (types: string[]) => {
                    const component = addressComponents.find((comp: any) =>
                        comp.types.some((type: any) => types.includes(type))
                    );
                    return component ? component.long_name : "";
                };
                props.OnChangeLocation({
                    city: getComponent(["postal_town", "locality"]),
                    country: props.property.heroSection?.address?.country,
                    latitude: results[0].geometry.location.lat(),
                    longitude: results[0].geometry.location.lng(),
                    subCommunity: getComponent(["route"]),
                    Community: getComponent(["administrative_area_level_2"]),
                    location: address,
                })

            } else {
                setError("Address not found.");
            }
        });
    };

    return (
        <>
            <div className="card border-16 mb-3">
                <div className=" padd-20">
                    <div className="mb-3">
                        <Autocomplete
                            freeSolo
                            className={`input-location back-F1F5F9 color-06 ${props.errors.address ? 'input-error' : ''}`}
                            sx={{
                                height: "auto !important"
                            }}
                            options={
                                (props.property.heroSection?.address?.country === "UK" || props.property.heroSection?.address?.country === "FR")
                                    ? options ?? []
                                    : (options || []).map((location: any) => location?.LOCATION || "")
                            }
                            inputValue={inputValue ?? ""}
                            onInputChange={(_, newValue) => {
                                setInputValue(newValue || "");
                                setError(null);

                                if (props.property.heroSection?.address?.country === "UK" || props.property.heroSection?.address?.country === "FR") {
                                    if (!autocompleteServiceRef.current) return;
                                    autocompleteServiceRef.current.getPlacePredictions(
                                        {
                                            input: newValue || "",
                                            componentRestrictions: {
                                                country: props.property.heroSection?.address?.country === "UK" ? "gb" : "fr"
                                            },
                                        } as any,
                                        (predictions) => {
                                            setOptions(predictions ? predictions.map((p) => p.description) : []);
                                        }
                                    );
                                } else {
                                    // Call backend location search for UAE
                                    if (newValue) {
                                        getLocations(newValue, props.property.heroSection?.address?.country).then((data) => {
                                            setOptions(data || []);
                                        }).catch(() => setOptions([]));
                                    } else {
                                        setOptions([]);
                                    }
                                }
                            }}
                            onChange={(event, newValue) => {
                                if (props.property.heroSection?.address?.country === "UK" || props.property.heroSection?.address?.country === "FR") {
                                    handleSelect(newValue);
                                } else {
                                    handleSelectChangeLocation(event, newValue, props.property.heroSection?.address?.country);
                                }
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder={t("generateDescTitle.cityCommunityorBuilding")}
                                    fullWidth
                                    error={!!error}
                                    helperText={error}
                                />
                            )}
                        />
                    </div>
                    <LoacationMaps position={[props.property.heroSection?.address?.latitude ?? 0, props.property.heroSection?.address?.longitude ?? 0]} zoomValue={14} address={props.property.heroSection?.address} height={400} />
                </div>
            </div>
        </>

    )
}

export default LocationReport;